import { apiWithAuth } from './api';

const API_URL = process.env.REACT_APP_API_URL;
if (!API_URL) {
  throw new Error('REACT_APP_API_URL environment variable is required.');
}

// Get all conversations for the current user
export const getConversations = async () => {
  try {
    const token = localStorage.getItem('token');
    const response = await apiWithAuth(token).get('/conversations/');
    return response.data;
  } catch (error) {
    console.error('Error fetching conversations:', error);
    throw error;
  }
};

// Create or get a conversation
export const createOrGetConversation = async (vendorId, organizerId, eventId = null, applicationId = null) => {
  try {
    const token = localStorage.getItem('token');
    
    // Build query parameters
    const params = new URLSearchParams();
    if (vendorId) params.append('vendor_id', vendorId);
    if (organizerId) params.append('organizer_id', organizerId);
    if (eventId) params.append('event_id', eventId);
    if (applicationId) params.append('application_id', applicationId);
    
    // Build URL with query parameters
    const finalUrl = params.toString() ? `/conversations/?${params.toString()}` : '/conversations/';
    
    console.log('Creating conversation with URL:', finalUrl);
    
    const response = await apiWithAuth(token).post(finalUrl);
    return response.data;
  } catch (error) {
    console.error('Error creating/getting conversation:', error);
    if (error.response) {
      console.error('Error response:', error.response.data);
      console.error('Error status:', error.response.status);
    }
    throw error;
  }
};

// Get messages for a conversation
export const getMessages = async (conversationId) => {
  try {
    const token = localStorage.getItem('token');
    const response = await apiWithAuth(token).get(`/conversations/${conversationId}/messages/`);
    return response.data;
  } catch (error) {
    console.error('Error fetching messages:', error);
    throw error;
  }
};

// Send a message
export const sendMessage = async (conversationId, content) => {
  try {
    const token = localStorage.getItem('token');
    const response = await apiWithAuth(token).post(`/conversations/${conversationId}/messages/`, {
      content: content,
    });
    return response.data;
  } catch (error) {
    console.error('Error sending message:', error);
    throw error;
  }
};

// Mark a message as read
export const markMessageRead = async (conversationId, messageId) => {
  try {
    const token = localStorage.getItem('token');
    const response = await apiWithAuth(token).put(`/conversations/${conversationId}/messages/${messageId}/read`);
    return response.data;
  } catch (error) {
    console.error('Error marking message as read:', error);
    throw error;
  }
};

// Mark all messages in a conversation as read
export const markAllMessagesRead = async (conversationId) => {
  try {
    const token = localStorage.getItem('token');
    const response = await apiWithAuth(token).put(`/conversations/${conversationId}/read-all`);
    return response.data;
  } catch (error) {
    console.error('Error marking all messages as read:', error);
    throw error;
  }
};

// Get unread message count
export const getUnreadMessageCount = async () => {
  try {
    const token = localStorage.getItem('token');
    const response = await apiWithAuth(token).get('/messages/unread-count');
    return response.data;
  } catch (error) {
    console.error('Error fetching unread count:', error);
    throw error;
  }
};


